import * as Yup from 'yup';

export const validationSchema = (localization: any) => {
    const requiredFieldMessage = localization.required_field_message;
    return Yup.object().shape({
        expirationDate: Yup.string().required(requiredFieldMessage).nullable()
    });
};
